<template>
    <ModalComponent
        :name="name"
        title="Exportar registros preventa"
        v-on:close="() => close()"
    >
        <template>
            <div class="card-body">
                <div class="row">
                    <div class="col-12 mb-3">
                        <label for="status">Estado</label>
                        <select class="custom-select" v-model="selectedStatus" id="status">
                            <option value="">Todos los estados</option>
                            <option value="pending">Pendiente</option>
                            <option value="selected">Aprobado</option>
                            <option value="rejected">Rechazado</option>
                        </select>
                    </div>
                    <div class="col-12">
                        <Button @click="exportar()" :disabled="loading">
                            <i v-if="loading" class="fas fa-spinner fa-spin mr-1"></i>
                            DESCARGAR
                        </Button>
                    </div>
                </div>
            </div>
        </template>
    </ModalComponent>
</template>

<script>
    import ModalComponent from "@/components/backend/components/ModalComponent";


    export default {
        props: ['name', 'evento_id'],
        data() {
            return {
                loading: false,
                selectedStatus: ''
            }
        },
        methods: {
            close() {
                this.selectedStatus = '';
                this.$emit('close', this.name);
            },
            exportar() {
                this.loading = true;

                const params = {
                    evento_id: this.evento_id,
                    filters: {}
                };

                if (this.selectedStatus) {
                    params.filters.status = this.selectedStatus;
                }

                this.$store.dispatch('BACK_EVENTS_PREVENTA_DESCARGAR_INFORME', params)
                    .then(res => {
                        const blob = new Blob([res.data], {
                            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                        });

                        const link = document.createElement('a');
                        link.href = window.URL.createObjectURL(blob);

                        const fileName = `registros-preventa-${this.evento_id}-${Date.now()}.xlsx`;
                        link.download = fileName;

                        document.body.appendChild(link);
                        link.click();

                        document.body.removeChild(link);
                        window.URL.revokeObjectURL(link.href);

                        this.$toast.success('Archivo descargado correctamente');
                        this.close();
                    })
                    .catch(error => {
                        console.error('Error al exportar:', error);
                        this.$toast.error('Error al exportar los registros');
                    })
                    .finally(() => {
                        this.loading = false;
                    });
            }
        },
        components: {
            ModalComponent
        }
    }
</script>
